import { render } from "./App.vue?vue&type=template&id=1d44ef8a"
const script = {}

import exportComponent from "../../../../../var/www/cry4change/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__